export const actionTypes = {
  GET_TRACK_INFO: "[Track] Get Track ",
  UPDATE_TRACK_INFO: "[Track] Update track ",
};

export const INITIAL_STATE = {};

export const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.GET_TRACK_INFO:
      return { ...state, loading: true };
    case actionTypes.UPDATE_TRACK_INFO:
      return { ...state, ...payload };

    default:
      return state;
  }
};

export const actions = {
  get_track: () => ({
    type: actionTypes.GET_TRACK_INFO,
    payload: true,
  }),
  update_track: (payload) => ({
    type: actionTypes.UPDATE_TRACK_INFO,
    payload,
  }),
};

//   export default reducer;
